import { useTheme } from "@/contexts/ThemeContext";

/**
 * Shows "Available anytime" or "Birthday only" label on offer cards
 * when the app is in Discover mode.
 */
export default function AvailabilityPill({ offer }) {
  const { mode } = useTheme();
  if (mode !== "discover") return null;

  const isBirthdayOnly = offer.birthday_offer !== false;

  if (isBirthdayOnly) {
    return (
      <span
        className="px-1.5 py-0.5 bg-orange-50 text-orange-600 border border-orange-200 rounded text-[10px] font-semibold"
        data-testid={`avail-pill-${offer.business_id}`}
      >
        Birthday only
      </span>
    );
  }

  return (
    <span
      className="px-1.5 py-0.5 bg-indigo-50 text-indigo-600 border border-indigo-200 rounded text-[10px] font-semibold"
      data-testid={`avail-pill-${offer.business_id}`}
    >
      Available anytime
    </span>
  );
}
